import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { ListsComponent } from '../../lists.shared.component';
import { ILoyaltyAppTransactionMenuFlow, ILoyaltyAppTransactionModel, ILoyaltyAppTransactionProduct } from '@shared/state';

@Component({
    selector: 'shared-list-for-transaction-items',
    templateUrl: './list-for-transaction-items.shared.component.html',
    styleUrls: ['./list-for-transaction-items.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForTransactionItemsComponent extends ListsComponent {
    @Input() public maxOnScreenHeight: string = null;
    @Input() public bottomPadding: boolean = false;
    @Input() public transaction: ILoyaltyAppTransactionModel;

    constructor() {
        super();
    }

    public trackBy(index: number, item: ILoyaltyAppTransactionProduct & ILoyaltyAppTransactionMenuFlow): number {
        return index;
    }

}
